import json from '../../json'
import router from '@/router/index'
var moment = require('moment')

// initial state
const state = {
  status: '',
  timeZones: [],
  activeTimeZone: null,
  error: ''
}

// getters
const getters = {
  error: state => state.error,
  timeZones: state => state.timeZones,
  activeTimeZone: state => state.activeTimeZone,
  status: state => state.status
}

// actions
const actions = {
  all ({ commit, state }) {
    if (state.status === 'init') {
      // すでにローディング済みの場合
      commit('setStatus', '')
      setTimeout(() => {
        commit('setStatus', 'init')
      })
    } else {
      commit('setStatus', '')
      json.get('/ope/master/mst_time_zone.json', undefined, true)
        .then(response => {
          commit('setTimeZones', response.data)
        })
        .catch(() => {
          router.push({ name: 'PageNotFound' })
        })
    }
  }
}

// mutations
const mutations = {
  setStatus (state, data) {
    state.status = data
  },
  setTimeZones (state, data) {
    // セル幅計算
    const pcScreenWidth = 970
    const lineWidth = 270
    const historyBtnWidth = 90
    const cellWidth = (pcScreenWidth - lineWidth - historyBtnWidth - (data.time_zones.length + 3) * 2) / data.time_zones.length
    const historyCellWidth = (pcScreenWidth - lineWidth - (data.time_zones.length + 2) * 2) / data.time_zones.length
    for (let t = 0; t < data.time_zones.length; t++) {
      data.time_zones[t].cellWidth = `${cellWidth}px`
      data.time_zones[t].historyCellWidth = `${historyCellWidth}px`
    }
    state.timeZones = data.time_zones
    state.activeTimeZone = null
    const now = parseInt(moment().format('HHmm'), 10)
    const now24 = now + 2400
    if (state.timeZones) {
      for (const timeZone of state.timeZones) {
        const startTime = parseInt(timeZone.start_time, 10)
        const endTime = parseInt(timeZone.end_time, 10)
        if (timeZone &&
          ((startTime <= now && endTime >= now) || (startTime <= now24 && endTime >= now24))) {
          state.activeTimeZone = timeZone.time_zone_id
        }
      }
    }
    state.status = 'init'
  },
  setError (state, response) {
    if (response && response.data && response.data.error) {
      state.error = response.data.error
    } else {
      state.error = 'サーバーに接続できません。'
    }
    state.status = 'error'
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/timeZone.js